module.exports = __webpack_public_path__ + "img/instagram-logo.b6796380.png";